import _get from 'lodash.get';

const getOrderDeliveries = (order) => {
  const deliveries = _get(order, 'company.order_settings.deliveries', {});
  return Object.keys(deliveries);
};

export default getOrderDeliveries;
